
import { LineChart } from '@mui/x-charts/LineChart';
import { ScatterChart } from '@mui/x-charts/ScatterChart';
import { generateHintsDistributionData, generateTimelineData } from '../libs/generateHintTimingSeriesData';

const data = [
  {
    id: "demo",
    data: [
      { x: "2023-01-01", y: 20 },
      { x: "2023-01-02", y: 45 },
      { x: "2023-01-03", y: 30 },
      { x: "2023-01-04", y: 80 },
    ],
  },
];

export default function Chart() {
  const lineChartData = generateHintsDistributionData();
  const timelineData = generateTimelineData();

  // Prepara i dati per lo ScatterChart (Timeline)
  const scatterData = timelineData.flatMap((game, gameIndex) =>
    game.data.map(point => ({
      x: point.x,
      y: gameIndex,
      id: `${game.id}-hint-${point.hint}`,
      hint: point.hint
    }))
  );

  // Crea le etichette per l'asse Y (nomi delle partite)
  const yAxisLabels = timelineData.map(game => game.id);

  return (
    <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
      {/* LineChart esistente */}
      <div style={{ height: '400px' }}>
        <h3>Timeline Aiuti - LineChart</h3>
        <LineChart
          series={lineChartData}
          width={800}
          height={300}
          xAxis={[
            {
              data: Array.from({length: 21}, (_, i) => i * 30), // 0, 30, 60, 90...
              label: 'Tempo (secondi)'
            }
          ]}
          yAxis={[
            {
              label: 'Numero Aiuto'
            }
          ]}
        />
      </div>

      {/* Nuovo Timeline Chart (ScatterChart) */}
      <div style={{ height: '500px' }}>
        <h3>Timeline Aiuti - Vista Temporale per Partita</h3>
        <ScatterChart
          series={[
            {
              data: scatterData,
              label: 'Richieste Aiuti'
            }
          ]}
          width={800}
          height={400}
          xAxis={[
            {
              min: 0,
              max: 600,
              label: 'Tempo (secondi)'
            }
          ]}
          yAxis={[
            {
              data: yAxisLabels,
              scaleType: 'band',
              label: 'Partite'
            }
          ]}
        />
      </div>
    </div>
  );
}